const fileKeyDecryptionError = 1559;
const fileCodeError = 1560;
const fileCodeAssetNotFound = 1561;

export { fileKeyDecryptionError, fileCodeError, fileCodeAssetNotFound };
